import { useState } from "react";
import styled from "styled-components";
import {mobile} from "../responsive";
import { useDispatch } from "react-redux"; //*useDispatch
import { useSelector } from "react-redux"; 
import React from "react";
const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://papers.co/wallpaper/papers.co-hu87-kpop-girl-iu-music-36-3840x2400-4k-wallpaper.jpg")
      center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 25%;
  padding: 20px;
  background-color: white;
  box-shadow:0 12px 15px 0 rgba(0,0,0,.24),0 17px 50px 0 rgba(0,0,0,.19);
  ${mobile({ width: "75%" })}
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  margin-bottom: 10px;
  &:disabled{
    color: black;
    cursor: pointer;
  }
`;

const Link = styled.a`
  margin: 5px 0px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`;
const Error =styled.span`
color:red;
font-size: 10px;
`
const Login = () => {
  //to use the state
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const dispatch = useDispatch() //react redux //login from apicall
  const {isFetching,error} = useSelector(state => state.user) //take the redux store
  
  
  return (
    <>
    <Container>
      <Wrapper>
        <Title>登入</Title>
        <Form>
          <Input placeholder="用戶名稱" onChange={(e)=>setUsername(e.target.value)}/>
          <Input placeholder="使用者密碼" type="password"
          onChange={(e)=>setPassword(e.target.value)}/>
        
          <Button >登入</Button>
          
          <Link>忘記密碼？</Link>
          <Link>創立一個新帳號</Link>
        </Form>
      </Wrapper>
    </Container>
    </>
  );
};

export default Login;
